import React from 'react';
import SMUSettingEditBaseFragment from './SMUSettingEditBaseFragment';
import SMFormFieldTitle from 'components/dashboard/form/SMFormFieldTitle';
import SMFormCheckBox from 'components/dashboard/form/SMFormCheckBox';
import SMUserResource from 'resources/SMUserResource';
import SMAppHelper from 'components/helpers/SMAppHelper';

class SMUSettingEditNotificationFragmentView extends SMUSettingEditBaseFragment {
  
  constructor(props) {
    super(props);
    this.formRequest = null;
    this.state = {
      user: this.props.user,
      isCurrent : this.isCurrent(this.props),
      errors: this.props.errors,
    };
  }
  
  componentDidMount() {
    if (this.isCurrent(this.props)) SMAppHelper.setTitle(I18n.t('dashboard.label_000023'));
    
    window.addEventListener('resize', this.sizeToFit.bind(this), false);
    if (this.state.isCurrent) this.sizeToFit();
  }
  
  componentWillUnmount() {
    window.removeEventListener('resize', this.sizeToFit.bind(this), false);
  }
  
  componentWillReceiveProps(nextProps) {
    this.setState({
      isCurrent : this.isCurrent(nextProps),
    });
  }
  
  componentDidUpdate() {
    if (this.state.isCurrent) this.sizeToFit();
  }
  
  getSettingAttribute(name){
    return name.match(/^setting\[(.+)]/)[1];
  }

  radioButtonDidChangeValue (e) {
    let currentTarget = e.currentTarget;
    this.setState(function(previousState, currentProps) {
      let attribute = this.getSettingAttribute(currentTarget.name);
      previousState.user.setting[attribute] = currentTarget.value;
      return{
        user: previousState.user,
      };
    });
  }

  formDidSubmit(e){
    e.preventDefault();
    
    let formData = new FormData(e.currentTarget);
    if (this.formRequest) this.formRequest.abort();
    this.formRequest = SMUserResource.updateUser(formData, {}, (user, error, xhr)=>{
      this.formRequest = null;
      if (error == "abort") return;
      if (xhr.status == 200) {
        this.setState({user: user});
        this.props.delegate.showSuccessMessage();
      } else {
        this.props.delegate.showFailMessage();
      }
    });
  }
  
  render() {
    return(
      <div style={this.fragmentStyle()}>
        <form onSubmit={this.formDidSubmit.bind(this)}>
          <SMFormFieldTitle title={I18n.t('dashboard.label_000184')} subTitle={I18n.t('dashboard.text_000036')} isRequired={true} />
          <div className="form-box">
            <div className="mb10">
              <input type="hidden" value="1" name="setting[can_receive_feature_mail]" />
              <input type="checkbox" value={0} id="form-checkbox01__07" name="setting[can_receive_feature_mail]" checked="checked" disabled="disabled"  />
              <label htmlFor="form-checkbox01__07" className="form-checkbox settings-notification__label-disabled">{I18n.t('dashboard.label_000217')}</label>
              <p className="dashboard-title__supplement settings-notification__description">システムメンテナンスの連絡など、スペースマーケットからのお知らせをお送りします。<br />このメールは大切なお知らせのため、受信解除することはできません。</p>
            </div>
            <div className="mb10">
              <input type="hidden" value="1" name="setting[can_receive_reservation_mail]" />
              <input type="checkbox" value={0} id="form-checkbox01__01" name="setting[can_receive_reservation_mail]" checked="checked" disabled="disabled" />
              <label htmlFor="form-checkbox01__01" className="form-checkbox settings-notification__label-disabled">{I18n.t('dashboard.label_000218')}</label>
              <p className="dashboard-title__supplement settings-notification__description">メッセージを受信したとき、お問い合わせや予約リクエストのステータス変更があったときなどにお知らせします。<br />このメールは大切なお知らせのため、受信解除することはできません。</p>
            </div>
            <div className="mb10">
              <input type="hidden" value="0" name="setting[can_receive_reminder_mail]" />
              <SMFormCheckBox name="setting[can_receive_reminder_mail]" id="form-checkbox01__02" value={1} checked={this.state.user.setting.can_receive_reminder_mail} delegate={this} />
              <label htmlFor="form-checkbox01__02" className="form-checkbox">{I18n.t('dashboard.label_000219')}</label>
              <p className="dashboard-title__supplement settings-notification__description">お問い合わせや予約リクエストについて、やるべきことがある場合にリマインドをお送りします。<br />受信設定にしておくことをおすすめします。</p>
            </div>
            <div className="mb10">
              <input type="hidden" value="0" name="setting[can_receive_recommend_mail]" />
              <SMFormCheckBox name="setting[can_receive_recommend_mail]" id="form-checkbox01__05" value={1} checked={this.state.user.setting.can_receive_recommend_mail} delegate={this} />
              <label htmlFor="form-checkbox01__05" className="form-checkbox">{I18n.t('dashboard.label_000222')}</label>
              <p className="dashboard-title__supplement settings-notification__description">今週のおすすめスペースなど、あなたへのおすすめスペースの情報をお送りします。</p>
            </div>
            <div className="mb10">
              <input type="hidden" value="0" name="setting[can_receive_coupon_mail]" />
              <SMFormCheckBox name="setting[can_receive_coupon_mail]" id="form-checkbox01__06" value={1} checked={this.state.user.setting.can_receive_coupon_mail} delegate={this} />
              <label htmlFor="form-checkbox01__06" className="form-checkbox">{I18n.t('dashboard.label_000223')}</label>
              <p className="dashboard-title__supplement settings-notification__description">スペース利用料を割引するお得なクーポン、キャンペーン情報をお送りします。</p>
            </div>
          </div>

          <SMFormFieldTitle title={I18n.t('dashboard.label_000188')} subTitle={I18n.t('dashboard.text_000037')} isRequired={true} />
          <div className="form-box">
            <div className="mb10">
              <input type="hidden" value="0" name="setting[can_receive_feature_push]" />
              <SMFormCheckBox name="setting[can_receive_feature_push]" id="form-checkbox02__04" value={1} checked={this.state.user.setting.can_receive_feature_push} delegate={this} />
              <label htmlFor="form-checkbox02__04" className="form-checkbox">{I18n.t('dashboard.label_000217')}</label>
              <p className="dashboard-title__supplement settings-notification__description">システムメンテナンスの連絡など、スペースマーケットからのお知らせをお送りします。<br />受信設定にしておくことをおすすめします。</p>
            </div>
            <div className="mb10">
              <input type="hidden" value="0" name="setting[can_receive_reservation_push]" />
              <SMFormCheckBox name="setting[can_receive_reservation_push]" id="form-checkbox02__01" value={1} checked={this.state.user.setting.can_receive_reservation_push} delegate={this} />
              <label htmlFor="form-checkbox02__01" className="form-checkbox">{I18n.t('dashboard.label_000218')}</label>
              <p className="dashboard-title__supplement settings-notification__description">メッセージを受信したとき、お問い合わせや予約リクエストのステータス変更があったときなどにお知らせします。<br />受信設定にしておくことをおすすめします。</p>
            </div>
            <div className="mb10">
              <input type="hidden" value="0" name="setting[can_receive_reminder_push]" />
              <SMFormCheckBox name="setting[can_receive_reminder_push]" id="form-checkbox02__02" value={1} checked={this.state.user.setting.can_receive_reminder_push} delegate={this} />
              <label htmlFor="form-checkbox02__02" className="form-checkbox">{I18n.t('dashboard.label_000219')}</label>
              <p className="dashboard-title__supplement settings-notification__description">お問い合わせや予約リクエストについて、やるべきことがある場合にリマインドをお送りします。<br />受信設定にしておくことをおすすめします。</p>
            </div>
            <div className="mb10">
              <input type="hidden" value="0" name="setting[can_receive_recommend_push]" />
              <SMFormCheckBox name="setting[can_receive_recommend_push]" id="form-checkbox02__03" value={1} checked={this.state.user.setting.can_receive_recommend_push} delegate={this} />
              <label htmlFor="form-checkbox02__03" className="form-checkbox">{I18n.t('dashboard.label_000222')}</label>
              <p className="dashboard-title__supplement settings-notification__description">今週のおすすめスペースなど、あなたへのおすすめスペースの情報をお送りします。</p>
            </div>
          </div>
          
          <input type='hidden' name='setting[id]' value={this.state.user.setting.id} />
          <input type='hidden' name='setting[user_id]' value={this.state.user.id} />

          <div ref="mainTableFooter" className="js-dashboard-main-table-footer maincol-buttonarea dashboard-maincol__right-inner-100pc">
            <input className="button-green maincol-buttonarea__button" type="submit" value="保存" />
          </div>
        </form>
      </div>
    );
  }
}
export default SMUSettingEditNotificationFragmentView;



// WEBPACK FOOTER //
// ./app/javascript/components/dashboard/users/settings/fragments/SMUSettingEditNotificationFragmentView.jsx